import { z } from 'zod'
import { presetBacktestRange } from '../previsions-produits/-search-schema'
import { toIsoDate } from '~/utils/dates/local-date'

export const correctionSearchSchema = z.object({
  tab: z.enum(['corrections', 'backtest']).default('corrections'),
  storeIds: z.array(z.number()).default([]),
  from: z.string().optional(),
  to: z.string().optional(),
  backtestStoreId: z.number().optional(),
})

export type CorrectionSearch = z.infer<typeof correctionSearchSchema>

export const defaultCorrectionRange = () => presetBacktestRange(7)

export const exclusiveEnd = (end: string): string => {
  const date = new Date(`${end}T00:00:00`)
  date.setDate(date.getDate() + 1)
  return toIsoDate(date)
}
